// apps/console/src/lib/netlifyFn.js
// Shared Netlify function caller. Extracted verbatim from the identical helper
// that previously lived in NhiRegistryPage.jsx and McpGatewayPage.jsx (no
// behavior change). POSTs JSON with the caller's Supabase bearer token.
import { supabase } from '@govern360/shared';

// G360_K524 - tenantId (optional) names the organisation on screen in the
// x-g360-tenant header. Omitted, nothing changes.
export async function callFn(name, payload, tenantId) {
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch(`/.netlify/functions/${name}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(tenantId ? { 'x-g360-tenant': tenantId } : {}), Authorization: `Bearer ${session?.access_token || ''}` },
    body: JSON.stringify(payload),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(j.error || `Request failed (${res.status})`);
  return j;
}
